import { Directive, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({ standalone: false,
  selector: '[docBlockCopyPaste]'
})
export class BlockCopyPasteDirective {

  @HostListener('paste', ['$event']) blockPaste(e: ClipboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: ClipboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: ClipboardEvent) {
    e.preventDefault();
  }

}

@NgModule({
  imports: [CommonModule],
  declarations: [BlockCopyPasteDirective],
  exports: [BlockCopyPasteDirective],
})
export class BlockCopyPasteDirectiveModule {}